module.exports = __webpack_public_path__ + "static/digital_precense-0f55dad33a55cf7e7151f51557325f6c.png";